// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1bjRw","headerWrapper":"f4Hw0","heading":"_3DqCZ","topSection":"L28rP","title":"gIT5v","infoPercentageq":"_1uS3p","subHeading":"_221PR","buttonWrapper":"_2zRJV"};